// Badge type for user achievements/badges
export interface Badge {
  id: number;
  name: string;
  description?: string;
  imageUrl?: string;      // camelCase
  image_url?: string;     // snake_case (backend might send this)
  priority: number;
}

// User.ts
export interface User {
  id: number;
  firstname: string;
  handle: string;
  lastname: string;
  email: string;
  password: string;
  picture: string;
  customer_id: string | null;
  role: Role;
  enabled: boolean;
  username: string;
  blacklist: Blacklist;
  account_non_expired: boolean;
  account_non_locked: boolean;
  credentials_non_expired: boolean;
  tokens: Token[];
  created_at?: string; // ISO date string for when user joined
  affiliated?: boolean; // Shows verification badge if true
  badges?: Badge[]; // User's earned badges
  last_active_at?: string; // ISO date string for last activity
  brawler_coin_balance?: number; // Brawler Coin balance
  residence_state?: string | null; // US state of residence (account tier of the centralized state source of truth)
  terms_accepted_version?: string | null; // Published Terms version this account agreed to
  terms_accepted_at?: string | null; // ISO date string of that agreement
}

interface Blacklist {
  bookmaker_keys: string[];
}


// Role.ts
export enum Role {
  USER = "User",
  BRONZE = "Bronze",
  SILVER = "Silver",
  GOLD = "Gold",
  ADMIN = "Admin"
}


export function stringToRole(roleStr: string): Role | null {
  const normalizedRoleStr = roleStr.toUpperCase();

  switch (normalizedRoleStr) {
    case "USER":
      return Role.USER;
    case "BRONZE":
      return Role.BRONZE;
    case "SILVER":
      return Role.SILVER;
    case "GOLD":
      return Role.GOLD;
    case "ADMIN":
      return Role.ADMIN;
    default:
      console.warn(`Unknown role: ${roleStr}`);
      return null;
  }
}




// Token.ts
enum TokenType {
  BEARER = "BEARER",
}

interface Token {
  id: number;
  token: string;
  tokenType: TokenType;
  revoked: boolean;
  expired: boolean;
  refreshToken: boolean;
  user: User;


}


